// extracted by mini-css-extract-plugin
export default {"modal_overlay":"modal_modal_overlay__B30+c","modal_wide":"modal_modal_wide__q6EgX","modal_box":"modal_modal_box__Pwc4J"};